import React from 'react'
import { Row ,Col} from 'react-bootstrap';
import { images } from '../../../utils/customFn';
import './agentbrokercard.scss'
const AgentBrokerCard = () => {
    return (
        <div className='agentbroker'>
            <Row>
                <Col md={6} sm={12} >
                    <div className='agent-card card1'>
                        <div className='wrapped-img'>
                            <img src={images['icon_of_two_people_seating_talking.svg']} alt='notes'/>
                        </div>
                        <div className='Content'>
                            <div className='Heading'>
                                <h3>For agents</h3>
                            </div>
                            <div className='Text'>
                                <p>We’re dedicated to appointing and supporting agents with experience and
                                    deep knowledge in their industries. Independent agents choose to work with
                                    us because we make it easy for them to provide their clients with valuable insights,
                                    industry-leading service, and customizable insurance solutions.</p>
                            </div>
                            <a className='link' href='/'>
                                <span>Request a middle market agency appointment {'>'}</span>
                            </a>
                        </div>
                    </div>
                </Col>
                <Col md={6} sm={12} >
                    <div className='agent-card'>
                    <div className='wrapped-img'>
                            <img src={images['icon_of_two_people_seating_talking.svg']} alt='notes'/>
                        </div>
                        <div className='Content'>
                            <div className='Heading'>
                                <h3>For brokers </h3>
                            </div>
                            <div className='Text'>
                                <p>We understand the unique challenges large, complex businesses like your clients face. 
                                    That’s why we offer customizable products and services backed by a committed, reliable team. We serve more than 500 elite large businesses from a range of industries. Many of these businesses have been with us for decades. 
                                    We’ve earned their trust, and we hope to earn yours.</p>
                            </div>
                            <a className='link' href='/'>
                                <span>Meet our large business team {'>'}</span>
                            </a>
                        </div>
                    </div>
                </Col>
            </Row>

        </div>
    )
}

export default AgentBrokerCard;
